import request from "../request";

export const getAllGranularSteps = (curriculumId, drId, lcId) =>
  request
    .get(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/${lcId}/granular-steps`
    )
    .then((res) => res);

export const createGranularStep = (curriculumId, drId, lcId, data) =>
  request
    .post(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/${lcId}/granular-steps`,
      data
    )
    .then((res) => res);

export const updateGranularStep = (curriculumId, drId, lcId, id, data) =>
  request
    .put(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/${lcId}/granular-steps/${id}`,
      data
    )
    .then((res) => res);

export const deleteGranularStep = (curriculumId, drId, lcId, id) =>
  request
    .delete(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/${lcId}/granular-steps/${id}`
    )
    .then((res) => res);

export const createWorkedExampleForGranularStep = (
  curriculumId,
  drId,
  lcId,
  gsId,
  data
) =>
  request
    .post(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/${lcId}/granular-steps/${gsId}/worked-examples`,
      data
    )
    .then((res) => res);

export const updateWorkedExampleForGranularStep = (
  curriculumId,
  drId,
  lcId,
  gsId,
  weId,
  data
) =>
  request
    .put(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/${lcId}/granular-steps/${gsId}/worked-examples/${weId}`,
      data
    )
    .then((res) => res);

export const deleteWorkedExampleForGranularStep = (
  curriculumId,
  drId,
  lcId,
  gsId,
  weId
) =>
  request
    .delete(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/${lcId}/granular-steps/${gsId}/worked-examples/${weId}`
    )
    .then((res) => res);
